import type { AsyncSequence } from "../types/AsyncSequence"
import type { Atom } from "../types/Atom"
import type { GUID } from "../types/GUID"

import { MapAsync } from "../async/MapAsync"
import { AtomToUint8 } from "../bytes/AtomToUint8"
import { UInt8Hash } from "./UInt8Hash"

/**
 * Computes SHA-256 hash of a stream of atomic values.
 *
 * Converts each atom to bytes and computes a deterministic hash.
 *
 * @param stream - Async sequence of atomic values (string | number | bigint | boolean)
 * @returns Promise resolving to GUID hash
 *
 * @example
 * ```ts
 * import { AtomHash } from "@pdfking/tfunc"
 *
 * const hash = await AtomHash(["hello", 42, true])
 * ```
 */
export const AtomHash = async (stream: AsyncSequence<Atom>): Promise<GUID> =>
  UInt8Hash(MapAsync(AtomToUint8, stream))
